import { AccountsState } from '../types';

export const accountState: AccountsState = {
  reports: [],
  account: null,
  searchKeyword: '',
  accountMetaTree: [],
  documentType: 'pdf',
  isExportDataRequestPending: false,
  isToggleExportFileModal: false,
  isToggleReportsListModal: false,
  isToggleGoogleMapApiKeyModal: false,
  isToggleCreateEditAccountModal: false,
  isLoadingEditAccount: false,
};
